App.factory('reportFactory', reportFactory);

reportFactory.$inject = ['DispatcherService'];

function reportFactory(DispatcherService) {
    return {
        query: function() {
            return DispatcherService.get('reports');
        },

        validate360: function(code) {
            return DispatcherService.get('reports/' + code + '/360');
        },
		
		validate2019360: function(code) {
            return DispatcherService.get('reports/' + code + '/360/2019');
        },
		
		validate2019prepost360: function(code) {
            return DispatcherService.get('reports/' + code + '/360/2019/respondents-pre-post');
        },

        generate360: function(code, excluded) {
            return DispatcherService.post('reports/' + code + '/360', { 'excluded': excluded });
        },

        generate360SupervisorsPrePost: function(code) {
            return DispatcherService.post('reports/' + code + '/360/supervisors-pre-post');
        },

        generate360RespondentsPrePost: function(code) {
            return DispatcherService.post('reports/' + code + '/360/respondents-pre-post');
        },

        generateSelf: function(code) {
            return DispatcherService.post('reports/' + code + '/self');
        },

        generateSelfPrePost: function(code) {
            return DispatcherService.post('reports/' + code + '/self/pre-post');
        },

        generate2019Self: function(code) {
            return DispatcherService.post('reports/' + code + '/2019self');
        },

        generate2019SelfPrePost: function(code) {
            return DispatcherService.post('reports/' + code + '/2019self/pre-post');
        },

        generate2019360Report: function(code, excluded) {
            return DispatcherService.post('reports/' + code + '/360/2019', { 'excluded': excluded });
        },
		
		generate2019360RespondentsPrePost: function(code, excluded) {
            return DispatcherService.post('reports/' + code + '/360/2019/respondents-pre-post', { 'excluded': excluded });
        },
    };
}
